import React from 'react';
import BaseHeader from "./BaseHeader";

export default function ItemHeader(props) {

    const item = props.item;

    const handleItemExit = (e) => {
        e.preventDefault();
        props.handleItemExit();
    };

    return <BaseHeader
        header={"Used "+item.year+" "+item.title}
        location={item.city+(item.state ? ', '+item.state : '')}
        isMobile={props.isMobile}
        exitUrl={props.exitUrl}
        handleItemExit={handleItemExit}
        actions={props.actions}
    />;

}
